import React from "react";

const benefits = [
  "No upfront payments",
  "Getting your activity online takes under 30 minutes",
  "Fixed commission on successful bookings",
];

const activities = [
  {
    title: "Day trips",
    list: ["Day trips", "Multi-day trips", "Private tours"],
  },
  {
    title: "Experiences and activities",
    list: [
      "Food experiences",
      "Courses and workshops",
      "Sport activities",
      "Water activities",
      "Adventure activities",
      "Tasting activities",
    ],
  },
  {
    title: "Sightseeing",
    list: [
      "Guided walking tours",
      "Nightlife and bar tours",
      "City cards",
      "Water activities",
      "City cruises",
      "Hop-on hop-off",
    ],
  },
  {
    title: "Tickets",
    list: ["Entry tickets", "Show and event tickets", "Wellness & spa"],
  },
  {
    title: "Services",
    list: ["Transfers", "Luggage storage"],
  },
  {
    title: "Other experiences",
    list: ["Bike/scooter rentals", "Audio guides", "Bundles"],
  },
];

function HomeActivitiesSection() {
  const handleGetStarted = () => {};
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl mb-10 text-center">
          Activities we welcome
        </span>
        <div className="bg-[#EBEFF959] py-10 px-4 lg:px-10 gap-10 rounded-md flex flex-col lg:flex-row justify-between mb-20 w-full flex-wrap">
          {activities.map((activity, index) => (
            <div key={index} className={Classname.activity}>
              <span className={Classname.title}>{activity.title}</span>
              <ul className="lg:list-disc">
                {activity.list.map((item, index) => (
                  <li key={index} className={Classname.detail}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="w-full flex items-center justify-center mb-10">
          <button
            className="h-14 w-80 bg-primary rounded-md flex items-center justify-center text-white text-sm lg:text-base font-bold"
            onClick={handleGetStarted}
          >
            Get Started
          </button>
        </div>

        <ul className="flex flex-col lg:flex-row gap-2 lg:gap-10 object-center list-disc text-sm mb-20 px-2">
          {benefits.map((benefit, index) => (
            <li className="" key={index}>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default HomeActivitiesSection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  title: " text-lg lg:text-xl font-bold  text-center lg:text-start max-w-56",
  detail: "text-sm lg:text-base text-center lg:text-start mb-2",
  activity:
    "flex lg:w-1/4 flex-col gap-4 items-center lg:items-start flex-shrink-0",
};
